import { $t } from "@/lib/i18nHelpers";
import config from "@/config";
import { FormField, FormFields } from "@/types";

export function personalIdFields(): (FormField & { meta?: Record<string, any> })[] {
  return [
    {
      name: "photo_container",
      type: "photoContainer",
      value: [
        {
          name: "id_photo",
          type: "inputFile",
          label: $t("Photo or scan of your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("id_photo"),
          },
        },
        {
          name: "photo_with_id",
          type: "inputFile",
          label: $t("Photo of holding your ID"),
          meta: {
            required: config.featurePayeeInfoRequiredFields.includes("photo_with_id"),
          },
        },
      ],
    },

    ...(config.disableAdult
      ? []
      : [
          { name: "sensitiveContent", type: "checkbox", rules: ["required"], meta: { title: $t("Sensitive content") } },
        ]),
  ];
}

export const personalInfoFields: FormFields = [
  {
    name: "firstName",
    label: $t("First name"),
    disabled: true,
    rules: {
      required: true,
      regex: /^[a-zA-Z]+$/,
    },
    rulesMessages: {
      regex: $t("Please enter only letters."),
    },
    validationMode: "aggressive",
    hint: $t("This information will be added later"),
  },
  {
    name: "lastName",
    label: $t("Last name"),
    disabled: true,
    rules: {
      required: true,
      regex: /^[a-zA-Z]+$/,
    },
    rulesMessages: {
      regex: $t("Please enter only letters."),
    },
    validationMode: "aggressive",
    hint: $t("This information will be added later"),
  },
  {
    name: "phone",
    label: $t("Phone number"),
    rules: ["required"],
    type: "phone",
    validationMode: "aggressive",
  },
];
